import { Layout } from 'react-grid-layout';
import { Widget } from '../Context/DashboardContext';

export interface DashboardState {
  dashboard: {
    id: string;
    status: 'draft' | 'published';
    widgets: Widget[];
    createdAt: string;
    updatedAt: string;
  };
  isInitialized: boolean;
}

export enum ActionTypes {
  UPDATE_DASHBOARD = 'UPDATE_DASHBOARD',
  ADD_WIDGET = 'ADD_WIDGET',
  REMOVE_WIDGET = 'REMOVE_WIDGET',
  UPDATE_LAYOUT = 'UPDATE_LAYOUT',
}

export type IActionType =
  | {
    type: ActionTypes.UPDATE_DASHBOARD;
    payload: {
      dashboard: DashboardState['dashboard'];
    };
  }
  | {
      type: ActionTypes.ADD_WIDGET;
      payload: Widget;
    }
  | { type: ActionTypes.REMOVE_WIDGET; payload: string }
  | { type: ActionTypes.UPDATE_LAYOUT; payload: Layout[] };

export function dashboardReducer(
  state: DashboardState,
  action: IActionType,
): DashboardState {
  switch (action.type) {
    case ActionTypes.UPDATE_DASHBOARD:
      return {
        ...state,
        dashboard: action.payload.dashboard,
        isInitialized: true,
      };

    case ActionTypes.ADD_WIDGET:
      const newWidget = action.payload;

      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          widgets: [...state.dashboard.widgets, newWidget],
          updatedAt: new Date().toISOString(),
        },
        isInitialized: true,
      };

    case ActionTypes.REMOVE_WIDGET:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          widgets: state.dashboard.widgets.filter(widget => widget.id !== action.payload),
          updatedAt: new Date().toISOString(),
        },
        isInitialized: true,
      };

    case ActionTypes.UPDATE_LAYOUT:
      const updatedWidgets = state.dashboard.widgets.map(widget => {
        const layoutItem = action.payload.find(item => item.i === widget.id);
        if (layoutItem) {
          return {
            ...widget,
            layout: layoutItem,
          };
        }
        return widget;
      });

      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          widgets: updatedWidgets,
          updatedAt: new Date().toISOString(),
        },
        isInitialized: true,
      };

    default:
      return state;
  }
}

export * from './dashboardManagerReducer';